import { WSAvatarIconProps } from "@wingspanhq/fe-component-library";
import {
  RecurringDocumentStatus,
  RecurringInvoice
} from "@wingspanhq/wingspan-api-sdk";

export const buildIcon = (
  recurringInvoice: RecurringInvoice
): Omit<WSAvatarIconProps, "type"> =>
  recurringInvoice.status === RecurringDocumentStatus.DRAFT
    ? {
        icon: "edit",
        colorBackground: "gray50",
        color: "gray500"
      }
    : {
        icon: "calendar",
        colorBackground: "gray50",
        color: "gray500"
      };
